// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/taf-wind-shear.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/taf-wind-shear/significant-wind-shear-guidelines.js';
import g1 from '../lessons/meteorology/taf-wind-shear/taf-wind-shear.js';
import g2 from '../lessons/meteorology/taf-wind-shear/wind-shear-source.js';

mount([g0, g1, g2]);
